import { render, staticRenderFns } from "./GiftsList.vue?vue&type=template&id=688774bf&scoped=true&"
import script from "./GiftsList.ts?vue&type=script&lang=ts&"
export * from "./GiftsList.ts?vue&type=script&lang=ts&"
import style0 from "./GiftsList.vue?vue&type=style&index=0&id=688774bf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "688774bf",
  null
  
)

export default component.exports